<!-- <div class="text-center">
    <h6 class="m-0 pb-16" style="white-space: pre-wrap; line-height: 1.4;">{{ title }}</h6>
    <div mat-dialog-content>
        <mat-spinner [style.margin]="'auto'"></mat-spinner>
    </div>
</div> -->

<div fxLayout="row wrap" class="row mt-16">
    <div fxFlex="100" fxFlex.gt-xs="100" class="text-center">
        <img style="border-radius: 8px;" src="assets/images/loader.gif" width="150" height="150" alt="logo" class="" />
    </div>
</div>